import IErrorConfig from "../../vendor_core/core/src/managers/contracts/configurations/IErrorConfig";
import { ConfigurationTypes } from "../../vendor_core/core/src/const/ConfigurationTypes";

class ErrorConfig implements IErrorConfig {
    public type: ConfigurationTypes = ConfigurationTypes.ERROR;
    public errorMap: { [key: string]: string } = {
        ERROR_57: "insufficientFunds"
    };
    public softErrorCodes: number[] = [57];

    public getErrorMap(): { [key: string]: string } {
        let errorMap = {};
        errorMap = Object.assign({}, this.errorMap);
        return errorMap;
    }

    public getSoftErrorCodes(): number[] {
        const softEC = [...this.softErrorCodes];
        return softEC;
    }

    public hasErrorMap(): boolean {
        return Object.keys(this.errorMap).length === 0;
    }

    public hasSoftErrorCodes(): boolean {
        return this.softErrorCodes.length > 0;
    }
}

export default new ErrorConfig();
